"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.Skins = void 0;
var React = require("react");
var IconButton_st_css_1 = require("./IconButton.st.css");
var button_next_1 = require("wix-ui-core/button-next");
var Skins;
(function (Skins) {
    Skins["Line"] = "line";
    Skins["Full"] = "full";
})(Skins = exports.Skins || (exports.Skins = {}));
/** An implementation of an IconButton for TPAs,
 * The TPA implementation provides few extendable theme properties with the ability to override the base properties as well.
 * By default the IconButton will pull the theme from the site (site color scheme) */
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function () {
        var _a = this.props, icon = _a.icon, disabled = _a.disabled, skin = _a.skin, className = _a.className, innerRef = _a.innerRef, rest = __rest(_a, ["icon", "disabled", "skin", "className", "innerRef"]);
        return (React.createElement(button_next_1.ButtonNext, __assign({ className: IconButton_st_css_1.st(IconButton_st_css_1.classes.root, { disabled: disabled, skin: skin }, IconButton_st_css_1.classes["skin-" + skin], className) }, rest, { ref: innerRef }),
            React.createElement("span", { className: IconButton_st_css_1.classes.icon }, icon)));
    };
    IconButton.displayName = 'IconButton';
    IconButton.defaultProps = { skin: Skins.Line };
    return IconButton;
}(React.Component));
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.js.map